import { getToken } from 'firebase/messaging'
import { messaging } from '../firebase'
import { useApi } from './api'

const VAPID_KEY = import.meta.env.VITE_FCM_VAPID_KEY
const STORAGE_KEY = 'fcm_token_updated'
const REFRESH_INTERVAL_MS = 24 * 60 * 60 * 1000 // 24時間

export const isNotificationGranted = (): boolean => {
  try { return Notification.permission === 'granted' } catch { return false }
}

export const getCurrentFcmToken = (): Promise<string | null> => {
  if (!messaging || !isNotificationGranted()) return Promise.resolve(null)
  return getToken(messaging, { vapidKey: VAPID_KEY }).catch(() => null)
}

export const registerFcmToken = (api: ReturnType<typeof useApi>): Promise<void> => {
  if (!messaging) return Promise.resolve()
  return getToken(messaging, { vapidKey: VAPID_KEY })
    .then(token => {
      return api.post('/notification-devices', { token }).then(() => {
        localStorage.setItem(STORAGE_KEY, String(Date.now()))
      })
    })
}

export const refreshFcmTokenIfNeeded = (api: ReturnType<typeof useApi>): void => {
  if (!isNotificationGranted()) return
  const last = Number(localStorage.getItem(STORAGE_KEY) || 0)
  if (Date.now() - last < REFRESH_INTERVAL_MS) return
  registerFcmToken(api).catch(() => {})
}
